import WebFont from 'webfontloader'

/**
 *  docs https://www.npmjs.com/package/webfontloader
 */
WebFont.load({
  google: {
    families: [
      'Roboto:100,100italic,300,300italic,400,400italic,500,500italic,700,700italic,900italic,900',
      'sans-serif',
    ],
  },
})
